<template>
  <div class="yb-view">
    <div class="yb-view-content-auto">
      <NuxtPage />
    </div>
  </div>
</template>
